import { LegislationApi } from '@core/api'
import { ProductProvider } from '@core/domain/product'

export default {
    data() {
        return {
            legislationQuestionnaire: [],
            legislationQuestionnaireLoading: false,
            legislationQuestionnaireRequestKey: null,
            legislationQuestionnaireLoadedKey: null,
            legislationQuestionAnswers: [],
            legislationQuestionAnswersLoading: false,
            legislationQuestionAnswersRequestProductId: null,
            legislationQuestionAnswersLoadedProductId: null,
        }
    },

    computed: {
        legislationQuestionnaireLegislationIds() {
            const ids = this.getLegislationQuestionnaireLegislations()
                .map(legislation => legislation && legislation.id)
                .filter(id => id !== undefined && id !== null)
                .map(id => Number(id))
                .filter(id => !Number.isNaN(id))

            return Array.from(new Set(ids))
                .sort((a, b) => a - b)
        },

        legislationQuestionnaireLegislationKey() {
            const scope = this.getLegislationQuestionnaireScope()

            return [
                this.legislationQuestionnaireLegislationIds.join(','),
                scope || '',
            ].join(':')
        },

        isRegulationQuestionsTabVisible() {
            return this.legislationQuestionnaire.length > 0
        },

        legislationQuestionnaireOverlayLoading() {
            return this.legislationQuestionnaireLoading || this.legislationQuestionAnswersLoading
        },
    },

    methods: {
        getLegislationQuestionnaireLegislations() {
            const productLegislations = this.product && this.product.legislations
                ? Object.values(this.product.legislations)
                : []

            if (productLegislations.length === 0) {
                return []
            }

            return this.applicableLegislations || []
        },

        getLegislationQuestionnaireScope() {
            return null
        },

        fetchLegislationQuestionnaire() {
            const legislationIds = this.legislationQuestionnaireLegislationIds
            const scope = this.getLegislationQuestionnaireScope()
            const requestKey = this.legislationQuestionnaireLegislationKey

            if (legislationIds.length === 0) {
                this.legislationQuestionnaire = []
                this.legislationQuestionnaireRequestKey = null
                this.legislationQuestionnaireLoadedKey = null
                return Promise.resolve([])
            }

            if (this.legislationQuestionnaireLoadedKey === requestKey) {
                return Promise.resolve(this.legislationQuestionnaire)
            }

            this.legislationQuestionnaireLoading = true
            this.legislationQuestionnaireRequestKey = requestKey

            return LegislationApi
                .getQuestionnaire(legislationIds, scope)
                .then(response => {
                    if (this.legislationQuestionnaireRequestKey !== requestKey) {
                        return this.legislationQuestionnaire
                    }

                    this.legislationQuestionnaire = Array.isArray(response.data) ? response.data : []
                    this.legislationQuestionnaireLoadedKey = requestKey
                    return this.legislationQuestionnaire
                })
                .catch(() => {
                    if (this.legislationQuestionnaireRequestKey === requestKey) {
                        this.legislationQuestionnaire = []
                        this.legislationQuestionnaireLoadedKey = null
                    }
                    return []
                })
                .finally(() => {
                    if (this.legislationQuestionnaireRequestKey === requestKey) {
                        this.legislationQuestionnaireLoading = false
                    }
                })
        },

        getLegislationQuestionAnswersProductId() {
            return this.id || null
        },

        fetchLegislationQuestionAnswers() {
            const productId = this.getLegislationQuestionAnswersProductId()

            if (!productId) {
                this.legislationQuestionAnswers = []
                this.legislationQuestionAnswersLoadedProductId = null
                return Promise.resolve([])
            }

            if (String(this.legislationQuestionAnswersLoadedProductId) === String(productId)) {
                return Promise.resolve(this.legislationQuestionAnswers)
            }

            this.legislationQuestionAnswersLoading = true
            this.legislationQuestionAnswers = []
            this.legislationQuestionAnswersRequestProductId = productId

            return ProductProvider(productId)
                .getLegislationQuestionAnswers()
                .then(answers => {
                    if (String(this.legislationQuestionAnswersRequestProductId) !== String(productId)) {
                        return this.legislationQuestionAnswers
                    }

                    this.legislationQuestionAnswers = Array.isArray(answers) ? answers : []
                    this.legislationQuestionAnswersLoadedProductId = productId
                    return this.legislationQuestionAnswers
                })
                .catch(() => {
                    if (String(this.legislationQuestionAnswersRequestProductId) === String(productId)) {
                        this.legislationQuestionAnswers = []
                        this.legislationQuestionAnswersLoadedProductId = null
                    }
                    return []
                })
                .finally(() => {
                    if (String(this.legislationQuestionAnswersRequestProductId) === String(productId)) {
                        this.legislationQuestionAnswersLoading = false
                    }
                })
        },
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.fetchLegislationQuestionAnswers()
            },
        },
        legislationQuestionnaireLegislationKey: {
            immediate: true,
            handler() {
                this.fetchLegislationQuestionnaire()
            },
        },
    },
}
